var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 0.8501C18.3687 1.42426 17.4851 1.86339 16.55 2.1506C16.0482 1.56198 15.3812 1.14479 14.6392 0.955437C13.8973 0.766086 13.1163 0.813716 12.4018 1.09189C11.6873 1.37005 11.0737 1.86534 10.6442 2.51076C10.2146 3.15618 9.98979 3.92059 10 4.7006V5.5506C8.53557 5.58933 7.08444 5.25804 5.77588 4.58623C4.46733 3.91442 3.34197 2.92294 2.50004 1.7001C2.50004 1.7001 -0.833292 9.3501 6.66671 12.7501C4.95048 13.9384 2.906 14.5342 0.833374 14.4501C8.33337 18.7001 17.5 14.4501 17.5 4.6751C17.4993 4.43834 17.477 4.20216 17.4334 3.9696C18.2839 3.11407 18.8841 2.03391 19.1667 0.8501V0.8501Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.71f5a6872c2ace858e9d4ae53e304a8c.svg";
export { ForwardRef as ReactComponent };